/* oxlint-disable react/jsx-no-literals */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, DocumentType } from '~/types/document';
import { formatFromISOToDisplay } from '~/utils/formatDate';

export const useShortDocumentLabel = () => {
  const { t } = useTranslation('documents');

  return useCallback(
    (documentType: DocumentType, documentNumber: string) => `${t(`type.${documentType}`)} ${documentNumber}`,
    [t],
  );
};

export const useDocumentLabel = () => {
  const { t } = useTranslation('documents');

  return useCallback(
    (document: Document) => {
      return (
        <>
          {t(`type.${document.documentType}`)}
          {document.number && <>&nbsp;•&nbsp;{document.number}</>}
          &nbsp;•&nbsp;{formatFromISOToDisplay(document.creationDate)}
        </>
      );
    },
    [t],
  );
};
